import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const locale = "sr";

export const studentGuardianManagement = createApi({
    reducerPath: "studentGuardianManagement",
    baseQuery: fetchBaseQuery({
        baseUrl: `${BASE_URL}`,
        prepareHeaders: (headers) => {
            const jwtToken = localStorage.getItem("userToken") || sessionStorage.getItem("userToken");

            if (jwtToken) {
                headers.set("authorization", `Bearer ${jwtToken}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        guardiansList: builder.mutation({
            query: (body) => {
                let url = `v1/${locale}/guardians`;

                for (const property in body) {
                    if ((property && body[property]) || (property === "startPage" && body[property] === 0)) {
                        if (url?.includes("?")) {
                            url += `&${property}=${body[property]}`;
                        } else {
                            url += `?${property}=${body[property]}`;
                        }
                    }
                }

                return {
                    url: url,
                    method: "GET",
                };
            },
        }),
        viewGuardian: builder.mutation({
            query: ({ guardianId }) => ({
                url: `v1/${locale}/guardians/${guardianId}`,
                method: "GET",
            }),
        }),
        updateGuardian: builder.mutation({
            query: ({ body, guardianId }) => ({
                url: `v1/${locale}/guardians/${guardianId}`,
                method: "PATCH",
                body: body,
            }),
        }),
        exportGuardians: builder.mutation({
            query: () => ({
                url: `v1/${locale}/export/guardians`,
                method: "GET",
                responseHandler: (response) => response.blob(),
            }),
        }),
    }),
});

export const {
    useGuardiansListMutation, 
    useUpdateGuardianMutation, 
    useViewGuardianMutation,
    useExportGuardiansMutation
} = studentGuardianManagement;
